import { render, staticRenderFns } from "./ReservationTags.vue?vue&type=template&id=1c7b12b3"
import script from "./ReservationTags.vue?vue&type=script&lang=js"
export * from "./ReservationTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports